import {
  getData,
  postData,
  getFileData,
} from './api-base.service';
import {downloadFile} from "@/config/mUtils";

export const downloadFileToBlob = (url, urlType = 1) => {
  return getFileData(url, {}, true, false, urlType);
}

export const getFileStorage = (fileStorageId) => {
  let data = {
    fileStorageId: fileStorageId
  };

  let result = getData('/FileStorage/GetFileStorage', data);
  return result;
}

export const saveCourseScoreFile = (studentSpeedupCourseId, fileData) => {
  let data = {
    StudentSpeedupCourseId: studentSpeedupCourseId,
    FileId: fileData.fileId,
    SourceFileName: fileData.sourceFileName,
    UploadFileName: fileData.uploadFileName,
    FileStorageType: fileData.fileStorageType
  };

  let result = postData('/FileStorage/SaveCourseScoreFile', data);
  return result;
}

export const getFileStorageListByWorkflowId = (workflowId) => {
  let data = {
    workflowId: workflowId
  };

  let result = getData('/FileStorage/GetFileStorageListByWorkflowId', data);
  return result;
}

export const removeFileStorage = (id, isDelete = false) => {
  let data = {
    id,
    isDelete
  };

  let result = getData('/FileStorage/RemoveFileStorage', data);
  return result;
}

export const saveWorkflowImageFiles = (workflowId, fileDataList) => {
  let data = [];
  fileDataList.forEach(fileData => {
    data.push({
      WorkflowId: workflowId,
      FileId: fileData.fileId,
      SourceFileName: fileData.sourceFileName,
      UploadFileName: fileData.uploadFileName,
      FileStorageType: fileData.fileStorageType
    });
  });

  let result = postData('/FileStorage/SaveWorkflowImageFiles', data);
  return result;
}

export const removeWorkflowImageFile = (workflowId, fileStorageId) => {
  let data = {
    workflowId: workflowId,
    fileStorageId: fileStorageId
  };

  let result = getData('/FileStorage/RemoveWorkflowImageFile', data);
  return result;
}

export const getBlobUrlByFileName = (sourceFileName, uploadFileName, fileStorageType) => {
  let data = {
    sourceFileName: sourceFileName,
    uploadFileName: uploadFileName,
    fileStorageType: fileStorageType
  };

  let result = getData('/FileStorage/GetBlobUrlByFileName', data);
  return result;
}

export const getBlobFileUrlById = (id, type = 1) => {
  let data = {
    id,
    type
  };
  return getData('/FileStorage/GetBlobFileUrlById', data);
}

export const saveUploadFile = (fileData) => {
  let data = {
    FileId: fileData.fileId,
    SourceFileName: fileData.sourceFileName,
    UploadFileName: fileData.uploadFileName,
    FileStorageType: fileData.fileStorageType
  };
  return postData('/FileStorage/SaveUploadFile', data);
}

export const saveUploadFiles = (fileDataList) => {
  let data = [];
  fileDataList.forEach(fileData => {
    data.push({
      FileId: fileData.fileId,
      SourceFileName: fileData.sourceFileName,
      UploadFileName: fileData.uploadFileName,
      FileStorageType: fileData.fileStorageType,
      FileSize: fileData.fileSize,
    });
  });
  return postData('/FileStorage/SaveUploadFiles', data);
}

export const getBlobStorageConfig = () => {
  let result = getData('/FileStorage/GetBlobStorageConfig');
  return result;
}

export const getSharedAccessSignature = (isViewOnly) => {
  if (typeof isViewOnly == "undefined") {
    isViewOnly = false;
  }
  let data = {
    isViewOnly: isViewOnly
  };
  let result = getData('/FileStorage/GetSharedAccessSignature', data);
  return result;
}

export const downloadFileWithName = (url, fileName) => {
 
  return new Promise((resolve, reject) => {
    downloadFileToBlob(url, 0).then((res) => {
      let isSuccess = true;
      if (!!res && !!res.data){
        try{
          console.log("downloadFileToBlob");
          downloadFile({ data: res.data, filename: fileName });
        }catch(e){
          isSuccess = false;
        }   
      }
      else {
        isSuccess = false;
        this.$message.error("未能正确获取到文件数据。");
      }

      console.log("download Blob result", isSuccess);
      if (isSuccess){
        resolve();
      }else{
        reject();
      }
    }).catch(()=>{
      reject();
    });
  }); 
}

export const downloadStorageFile = (fileId) => {
  getBlobFileUrlById(fileId)
    .then((result) => {
      if (!!result && result.success) {
        let { Url, FileName } = result.data;
        downloadFileWithName(Url, FileName);
      } else {
        if (!!result.message) {
          this.$message.error(result.message);
        }
      }
    })
    .catch(() => {});
}


// WEBPACK FOOTER //
// ./src/service/blobStorage.service.js